import { useEffect, useRef } from 'react';
import { renderAsync } from 'docx-preview';

const DocxViewer = ({ url }: { url: string }) => {
	const containerRef = useRef(null);

	useEffect(() => {
		if (!url) return;

		fetch(url)
			.then((response) => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.blob();
			})
			.then((blob) => {
				if (containerRef.current) {
					renderAsync(blob, containerRef.current);
				}
			})
			.catch((error) => {
				console.error('Error fetching or rendering the DOCX file:', error);
			});
	}, [url]);

	return (
		<div
			ref={containerRef}
			style={{
				width: '100%',
				height: '100vh',
				overflow: 'auto',
			}}
		/>
	);
};

export default DocxViewer;
